import { Alert, AlertDescription, AlertIcon, AlertTitle, Center, Flex, Stack } from '@chakra-ui/react'

export const LoadingFailedAlert = () =>{

  return <Center>
    <Alert as={Stack} alignItems='start' status="error" maxW='md' m={4}>
      <Flex>
        <AlertIcon />
        <AlertTitle>Došlo k chybě.</AlertTitle>
      </Flex>
      <AlertDescription>
        Při načítání dat došlo k chybě. Zkuste stránku obnovit nebo kontaktujte podporu.
      </AlertDescription>
    </Alert> 
  </Center>
}